'use strict';

angular.module('TurneroApp').component('coAgendaPaso2', {
	bindings: {
		centroAtencionSeleccionado: '<',
		ctrlPadre: '='
	}, controller: [
		 '$scope',
		 '$rootScope',
		 '$q',
		 'agendaService',
		 'TurneroAppConstant',
		 'tramiteService',
		 'unidadService',
		 'utilsService',
	function ($scope, $rootScope, $q, agendaService, TurneroAppConstant, tramiteService, unidadService, utilsService) {
		var ctrl = this;
		ctrl.Estados = TurneroAppConstant.Estados.Agenda;
		ctrl.limpiarMemoria = function () {
			ctrl.Agenda = {
				Id_Agenda: null,
				Es_Agenda_Suac: 'N',
				Tramites_Alta: '',
				Tramites_Baja: '',
				Tramites_Agenda: [],
				Id_Estado: 0
			}
		};

		ctrl.buscarUnidad = function (texto) {

			return unidadService.get({ 'texto': texto }).$promise.then(function (resultado) {
				ctrl.searchT = null;
				ctrl.Tramite = null;

				return resultado;
			}).catch(function (error) {
				utilsService.errores(error);
			});
		};

		ctrl.ObtenerTramites = function (Texto, Id_Unidad) {
			return tramiteService.tramitesXUnidad({ 'filtro.Texto': Texto || '', 'filtro.Id_Unidad': Id_Unidad }).$promise.then(function (resultado) {
				ctrl.Tramites_Lista = resultado.Data;
				return resultado.Data;
			}).catch(function (error) {
				utilsService.errores(error);
				return null;
			});
		};

		ctrl.ObtenerInfo = function (Tramite) {
			if (Tramite && Tramite.Id_Padre) {
				unidadService.getById({ 'id_unidad': Tramite.Id_Padre }).$promise.then(function (data) {
					ctrl.Unidad = data;
				}).catch(function (error) {
					utilsService.errores(error);
				});
			}
		};

		//Obtengo los datos para el load del paso 2 (carga inicial)
		$scope.$on('inicioAgendaPaso2_load', function (event, obj) {
			ctrl.limpiarMemoria();
			ctrl.Agenda.Id_Agenda = obj.Id_Agenda;
			ctrl.agendaNueva = obj.isNew;
			if (ctrl.Agenda.Id_Agenda != null) {
				utilsService.swalNotification('Cargando datos.', 'Obteniendo la información y los trámites de la agenda.', 'info');
				agendaService.Get_Paso2({ 'id_agenda': ctrl.Agenda.Id_Agenda }).$promise.then(function (resultado) {
					ctrl.Agenda = resultado.Data;
					ctrl.Agenda.Tramites_Agenda = ctrl.Agenda.Tramites_Agenda == null ? [] : ctrl.Agenda.Tramites_Agenda;
					ctrl.Agenda.Tramites_Agenda.forEach(function (item) {
    					if (!item.Solicita_Patente) {
       	 					item.Solicita_Patente = 'N';
    					}
					});
					ctrl.Agenda.Es_Agenda_Suac = ctrl.Agenda.Es_Agenda_Suac == '' ? 'S' : ctrl.Agenda.Es_Agenda_Suac;
					ctrl.Agenda.Tramites_Baja = ''
					ctrl.Agenda.Tramites_Alta = ''
					ctrl.Agenda.Id_Tramite_Aplicacion = null;
					ctrl.Agenda.Tiene_Tramite_Aplicacion = false;
					if (ctrl.Agenda.Tramites_Aplicacion) {
						for (var i = 0; i < ctrl.Agenda.Tramites_Aplicacion.length; i++) {
							if (ctrl.Agenda.Tramites_Aplicacion[i].Id_Seleccionado) {
								ctrl.Agenda.Tiene_Tramite_Aplicacion = true;
								ctrl.Agenda.Id_Tramite_Aplicacion = ctrl.Agenda.Tramites_Aplicacion[i].id;
								break;
							}
						}
					}

					swal.close();
				}).catch(function (error) {
					utilsService.errores(error);
					swal.close();
				});
			}
		});

		//funcion boton cancelar, que redirecciona a pantalla de consulta
        ctrl.cancelar = function (mostrarMensaje = false) {
            if (mostrarMensaje) {
                ctrl.ctrlPadre.mostrarMensajeFinal();
            } else {
                ctrl.limpiarMemoria();
                ctrl.ctrlPadre.consultaAgendas(true);
            }
        };

		//guardar los cambios en el paso 2.
		ctrl.guardarPaso2 = function (paso_siguiente) {
			if (ctrl.ctrlPadre.readOnly) {
				ctrl.ctrlPadre.inicioAgendaPaso3(true, true, ctrl.Agenda.Id_Agenda);
			} else {
				utilsService.swalTitle('Procesando datos.', 'info');
				if (ctrl.validarForm()) {
					if (ctrl.Agenda.Id_Agenda != null) {
						agendaService.Put_Agenda_Paso2(({ 'id': ctrl.Agenda.Id_Agenda }, ctrl.Agenda)).$promise.then(function (result) {
						    swal.close();
						    if (result.Data && result.Data.length > 0) {
						        swal({
						            title: 'Trámites repetidos',
						            html: "Uno de los trámites ya existe online para otra agenda. Presione aceptar si desea exportar el listado a excel.",
						            type: 'info',
						            confirmButtonColor: '#004b81',
						            confirmButtonText: 'Aceptar',
						            showCancelButton: true,
						            allowEscapeKey: false,
						            allowOutsideClick: false,
						            cancelButtonColor: '#971b2f',
						            cancelButtonText: 'Cancelar'
						        }).then(function (respuesta) {
						            if (respuesta === true) {
						                exportarExcel(result.Data);
						            }

						        })
						    } else {

						        if (paso_siguiente) {
						            ctrl.ctrlPadre.inicioAgendaPaso3(true, ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente, ctrl.Agenda.Id_Agenda);
						        } else {
                                    ctrl.cancelar(true);
						        }
						    }
                        }).catch(function (error) {
                            swal.close();
							utilsService.errores(error);
						});
					}
				}
			}
		};
	
		ctrl.validarForm = function () {
			ctrl.Agenda.Tramites_Alta = '';
			ctrl.Agenda.Tramites_Baja = '';
			if (ctrl.Agenda.Es_Agenda_Suac == 'N') {
				if (ctrl.Agenda.Tramites_Agenda && ctrl.Agenda.Tramites_Agenda.length > 0) {
					ctrl.Agenda.Id_Tramite_Aplicacion = ctrl.Agenda.Tiene_Tramite_Aplicacion ? ctrl.Agenda.Id_Tramite_Aplicacion : null;
                    for (var i = 0; i < ctrl.Agenda.Tramites_Agenda.length; i++) {
                        ctrl.Agenda.Tramites_Agenda[i].Turnos_Subsiguientes = ctrl.Agenda.Tramites_Agenda[i].Turnos_Subsiguientes === '' || ctrl.Agenda.Tramites_Agenda[i].Turnos_Subsiguientes === undefined || ctrl.Agenda.Tramites_Agenda[i].Turnos_Subsiguientes === null ? 'N' : ctrl.Agenda.Tramites_Agenda[i].Turnos_Subsiguientes;
						var tramiteItem = ctrl.Agenda.Tramites_Agenda[i];
						//si la agenda NO permite patente, fuerzo a que el tramite no lo solicite
						if (ctrl.Agenda.Solicita_Patente !== 'S') {
        					tramiteItem.Solicita_Patente = 'N';
   						}
						if (tramiteItem.Id_Estado == 1) {
                            ctrl.Agenda.Tramites_Alta =
                                ctrl.Agenda.Tramites_Alta == '' ? ((tramiteItem.Id_Tramite_Agenda ? tramiteItem.Id_Tramite_Agenda : 'null') + ',' + tramiteItem.Id_Tramite_Relevado + ',' + tramiteItem.Max_Turnos_Dia + ',' + tramiteItem.Dias_Anticipacion + ',' + tramiteItem.Id_Prioridad + ',' + tramiteItem.Turnos_Subsiguientes + ',' + (tramiteItem.Solicita_Patente || 'N')) :
                                ctrl.Agenda.Tramites_Alta + ('|' + (tramiteItem.Id_Tramite_Agenda ? tramiteItem.Id_Tramite_Agenda : 'null') + ',' + tramiteItem.Id_Tramite_Relevado + ',' + tramiteItem.Max_Turnos_Dia + ',' + tramiteItem.Dias_Anticipacion + ',' + tramiteItem.Id_Prioridad + ',' + tramiteItem.Turnos_Subsiguientes + ',' + (tramiteItem.Solicita_Patente || 'N'))


						} else if (tramiteItem.Id_Estado == 0) {
							if (tramiteItem.Id_Tramite_Agenda) {
								ctrl.Agenda.Tramites_Baja = ctrl.Agenda.Tramites_Baja == '' ? tramiteItem.Id_Tramite_Agenda :
									ctrl.Agenda.Tramites_Baja + ',' + tramiteItem.Id_Tramite_Agenda;
							}
						}

					}
				}

			} else {
				ctrl.Agenda.Id_Tramite_Aplicacion = null;
				ctrl.Agenda.Tiene_Tramite_Aplicacion = false;
			}


			if (ctrl.Agenda.Es_Agenda_Suac == 'N' && (ctrl.Agenda.Tramites_Agenda.length == 0 || ctrl.Agenda.Tramites_Agenda.length == (ctrl.Agenda.Tramites_Baja.toString()).split(',').filter(x => x).length)) {
				swal({
					title: 'Error',
					text: 'Debe seleccionar al menos un trámite.',
					type: 'warning',
					allowEscapeKey: false,
					allowOutsideClick: false,
					confirmButtonText: 'Aceptar'
				});
				return false;
			}
			if (ctrl.Agenda.Tiene_Tramite_Aplicacion && !ctrl.Agenda.Id_Tramite_Aplicacion) {
				swal({
					title: 'Error',
					text: 'Debe seleccionar al menos un formulario externo.',
					type: 'warning',
					allowEscapeKey: false,
					allowOutsideClick: false,
					confirmButtonText: 'Aceptar'
				});
				return false;
			}
			return true;
		};

		ctrl.switchTab = function (paso, funcion) {
			var pasoActual = 1;
			if (ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente && pasoActual > paso) {
				ctrl.cambiarVista(funcion);
			} else if (ctrl.Agenda.Id_Estado != TurneroAppConstant.Estados.Agenda.Pendiente) {
				ctrl.cambiarVista(funcion);
			}
		};

		// cambiar de vista. sobretodo para el boton atras.-
		ctrl.cambiarVista = function (funcion) {
			funcion(true, ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente, ctrl.Agenda.Id_Agenda);
		};

		//agregar un tramite seleccionado a la lista de tramites de la agenda
		ctrl.agregarTramiteSeleccionado = function (item) {
			//si no es SUAC puedo agregarlo
			if (ctrl.Agenda.Es_Agenda_Suac == 'N') {
				var existe = false;
				//inicializo la lista
				ctrl.Agenda.Tramites_Agenda = !ctrl.Agenda.Tramites_Agenda ? [] : ctrl.Agenda.Tramites_Agenda;
				//recorro la lista de tramites
				for (var i = 0; i < ctrl.Agenda.Tramites_Agenda.length; i++) {
					//si existe algun objeto que coincida
					if (item.id == ctrl.Agenda.Tramites_Agenda[i].Id_Tramite_Relevado) {
						existe = true;
						//si coincide y esta inactivo lo activo, sino no hace nada
						if (ctrl.Agenda.Tramites_Agenda[i].Id_Estado == 0) {
							ctrl.Agenda.Tramites_Agenda[i].Id_Estado = 1
						}
						break;
					}
				}
				if (!existe) {
					ctrl.Agenda.Tramites_Agenda.push({
						'Id_Tramite_Agenda': null,
						'Id_Tramite_Relevado': item.id,
						'N_Tramite': item.text,
						'Max_Turnos_Dia': 0,
						'Dias_Anticipacion': 0,
						'Id_Prioridad': 0,
						'Id_Estado': 1,
						'Solicita_Patente': 'N'
					})
				}
				ctrl.Unidad = null;
				ctrl.Tramite = null;
			}
		}

		//agregar todos los tramites en el listado de tramites
		ctrl.agregarTodosLosTramites = function (Texto, Id_Unidad) {
			tramiteService.tramitesXUnidad({ 'filtro.Texto': Texto || '', 'filtro.Id_Unidad': Id_Unidad }).$promise.then(function (resultado) {
				var listaTramites = resultado.Data;
				if (listaTramites.length) {
					swal({
						title: 'Agregar todos los trámites?',
						html: "Esta seguro que desea agregar " + listaTramites.length + ' trámites a la lista.',
						type: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Confirmar',
						allowEscapeKey: false,
						allowOutsideClick: false
					}).then(
					function () {
						utilsService.swalTitle('Cargando trámites a la lista.', 'info');
						for (var i = 0; i < listaTramites.length; i++) {
							ctrl.agregarTramiteSeleccionado(listaTramites[i])
						}
						swal(
						  'Se realizó con éxito!',
						  'Se agregaron los ' + listaTramites.length + ' trámites a la lista.',
						  'success'
						)
						$scope.$apply();
					})
				} else {
					swal(
						  'No hay trámites',
						  'No se han encontrado trámites disponibles para esta Unidad.',
						  'warning'
						)
				}
			}).catch(function (error) {
				utilsService.errores(error);
			});
			
		};

		ctrl.eliminarItem = function (item) {
			swal({
				title: 'Eliminar trámite.',
				html: 'Esta seguro que desea eliminar el trámite "' + item.N_Tramite + '" de la agenda.</br> </br><strong><small>Recuerde guardar los cambios, antes de salir.</small></strong>',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Confirmar',
				allowEscapeKey: false,
				allowOutsideClick: false
			}).then(function () {
				//lo desactivo de la lista
				item.Id_Estado = 0;
				$scope.$apply();
			})
			
			
		};

		function exportarExcel(data) {
		    var arrayObject = data;
		    ctrl.arrayExport = [];
		    ctrl.arrayExport[1] = ['Número y Nombre de Trámite', 'Número y Nombre de Agenda'];
		    for (var i = 0; i < arrayObject.length; i++) {
		        var index = ctrl.arrayExport.length;
		        ctrl.arrayExport[ctrl.arrayExport.length] = [arrayObject[i].Tramite, arrayObject[i].Agendas[0]];
		        for (var j = 1; j < arrayObject[i].Agendas.length; j++) {
		            ctrl.arrayExport[ctrl.arrayExport.length] = [' ', arrayObject[i].Agendas[j]];
		        }

		    }
		    swal.close();
		    ctrl.Excel.down([{
		        name: 'Tramites_Repetidos',
		        data: ctrl.arrayExport
		    }]);

		}
		ctrl.Excel = {
		    down: function () {
		    },
		}
	}
	],
	template: require('./agenda_Paso2.html')
});



// WEBPACK FOOTER //
// ./app/components/agenda/agenda_Paso2Component.js